import React, { Component } from "react";

class Reactor extends Component {
    static scrollListeners = [];
    static windowScrollListenerAdded = false;
    static id = 1;

    state = { visible: false, seenAtLeastOnce: false };
    observer = null;

    constructor(props) {
        super(props);

        if (!Reactor.windowScrollListenerAdded) {
            Reactor.windowScrollListenerAdded = true;
            if (document.addEventListener) {
                document.addEventListener("scroll", (e) => {
                    Reactor.scrollListeners.forEach(listener => listener(e));
                    return true;
                });
            } else {
                document.onscroll = (e) => {
                    Reactor.scrollListeners.forEach(listener => listener(e));
                    return true;
                };
            }
        }

        this.id = `Reactor-${Reactor.id++}`;
        this.listenerIndex = null;
    }

    mergeState = (newState) => this.setState(oldState => ({ ...oldState, ...newState }));

    elementYOffset = (element) => {
        let offset = 0;
        do {
            offset += element.offsetTop;
            element = element.offsetParent;
        } while (element);
        return offset;
    }

    elementIsVisible = () => {
        let element = document.getElementById(this.id);
        
        if (!element || element.offsetParent === null) {
            return false;
        }

        let viewportTop = window.pageYOffset || document.documentElement.offsetTop;
        let viewportBottom = viewportTop + window.innerHeight;
        let elementTop = this.elementYOffset(element);
        let elementBottom = elementTop + element.offsetHeight;

        return (viewportTop <= elementTop && elementTop <= viewportBottom) || (viewportTop <= elementBottom && elementBottom <= viewportBottom);
    }

    updateElementVisibility = (event) => {
        let elementIsVisible = this.elementIsVisible();

        /* if the element is visible */
        this.props.onVisible && elementIsVisible && this.props.onVisible(event);

        /* update element visibility */
        elementIsVisible ? this.mergeState({ visible: true, seenAtLeastOnce: true }) : this.mergeState({ visible: this.props.triggerOnce === true && this.state.seenAtLeastOnce, revealed: false });
    }

    componentDidMount() {
        Reactor.scrollListeners.push(this.updateElementVisibility);

        if (this.elementIsVisible()) {
            this.props.onVisible && this.props.onVisible();
            this.props.onReveal && this.props.onReveal();
            this.mergeState({ visible: true, revealed: true });
        }
    }

    componentWillUnmount() {
        let index = Reactor.scrollListeners.indexOf(this.updateElementVisibility);
        Reactor.scrollListeners.splice(index, 1);
    }

    renderChildren() {
        if (this.props.children.constructor === Function) {
            return this.props.children(this.state);
        }
        return this.props.children;
    }

    render() {
        return (
            <div id={this.id} className={this.props.className || ""}>
            {this.renderChildren()}
            </div>
        );
    }
}

export default Reactor;